// Events
import { CART_STAGE_UPDATE, THEME_CART_UPDATED } from 'events';
import { component } from 'picoapp';

// Utils
import choozy from 'utils/choozy';
import formatMoney from 'utils/format-money';

export default component((node, ctx) => {
  const { subtotalPrice, totalPrice, discounts, discountsTitle } = choozy(node);

  const updateSummary = (cart, variantsPrices) => {
    if (subtotalPrice) subtotalPrice.textContent = formatMoney(cart.original_total_price);
    if (totalPrice) totalPrice.textContent = formatMoney(cart.total_price);
    if (discounts && discountsTitle) {
      const totalDiscount = cart.items.reduce((acc, item) => {
        const originalLinePrice = variantsPrices[item.variant_id]
          ? variantsPrices[item.variant_id] * item.quantity
          : item.original_line_price;
        const priceDiff = originalLinePrice - item.final_line_price;
        return acc + priceDiff;
      }, 0);
      discounts.textContent = totalDiscount ? formatMoney(totalDiscount) : '';
      discounts.classList[totalDiscount > 0 ? 'remove' : 'add']('hidden');
      discountsTitle.classList[totalDiscount > 0 ? 'remove' : 'add']('hidden');
    }
  };

  ctx.on(THEME_CART_UPDATED, ({ cart, variantsPrices }) => {
    updateSummary(cart, variantsPrices);
  });

  ctx.on(CART_STAGE_UPDATE, (state, updatedCart) => {
    const { variantsPrices } = ctx.getState();

    updateSummary(updatedCart, variantsPrices);
  });
});
